import React from 'react';
import { View } from 'react-native';
import RatingStarComponent from "./RatingStarComponent";

const RatingDisplay = (props) => {

    const { points } = props;

    return (
        <View style={{ flexDirection: 'row', flex: 1, justifyContent: 'space-around' }}>
            <RatingStarComponent starId={1} starPressed={points} />
            <RatingStarComponent starId={2} starPressed={points} />
            <RatingStarComponent starId={3} starPressed={points} />
            <RatingStarComponent starId={4} starPressed={points} />
            <RatingStarComponent starId={5} starPressed={points} />
        </View>
    )

}

export default RatingDisplay;
